import React, { createRef, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Control } from 'react-redux-form';
import { Row, Col, OverlayTrigger, Popover } from 'react-bootstrap';
import Translation from '../../../../../common/translation/translation.component';
import { TRANSLATIONS as translation, EQUIPMENT_TYPE as EquipmentType, CIRCUIT_TYPES as CircuitTypes } from '../../../../../../utils/constant.utils';
import {
    OR_RRF_Select as Select
    , ORFButton as Button
    , ORFSelect
    , ORFField
} from '../../../../../common/forms/order-request-form.component';
import { newMobileSubscriptionActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireless-request/new-mobile-subscription.reducer";
import { CheckBox } from '../../../../../common/custom-form/checkbox.component';
import TableWithButton from '../../../../../common/details-table/table-with-button.component';
import { ControlCheckBox } from '../../../../../common/custom-form/checkbox.component';
import CustomSearchableSelectWrapper from '../../../../../common/custom-form/custom-searchable-select-wrapper.component';
import { MAX_LENGTH } from '../../../../../../constants/external-constants';
import { addZeroes } from '../../../../../../../../src/app/store/external/request-reducer/order-request.functions';

class WirelessSubscriptionFormA extends Component {
    constructor(props) {
        super(props);
        this.state={
            serviceTypeExist: false,
            serviceTypeExistOnprogress: false,
            isDevice:false
        }
    }

    componentDidMount() {    
        this.props.onSubscriptionFormLoad();
    }

    componentDidUpdate(prevProps) {
        const { wirelessSubscriptionFormA } = this.props;
        const { 
              employeeEquipmentProductNames
            , employeeEquipmentOnprogressProductNames } = this.props.newMobileRequest;
    
        if (wirelessSubscriptionFormA.mobileServiceModel !== prevProps.wirelessSubscriptionFormA.mobileServiceModel) {
            const productNamesFilter = employeeEquipmentProductNames.filter(name=>name)
            const productNames = productNamesFilter.includes(
            wirelessSubscriptionFormA.mobileServiceModel.length > 0 &&
            wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentProductName
          );

          this.setState({ serviceTypeExist: productNames });
          
          const onProgressProductNameFilter=employeeEquipmentOnprogressProductNames.filter(name=>name)
          const onProgressProductNames = onProgressProductNameFilter.includes(
            wirelessSubscriptionFormA.mobileServiceModel.length &&
            wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentProductName
          );

          this.setState({ serviceTypeExistOnprogress: onProgressProductNames });
    
          const device = (wirelessSubscriptionFormA.mobileServiceModel.length > 0 ?
            wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentTypeId === EquipmentType.Device : false
          );

          this.setState({ isDevice: device });
        }
      }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    renderPopover = (title, body) => {
        return (
            <Popover id="comp-popover" title={title} className="plan-comp-popover">
                {body}
            </Popover>
        );
    };

    handlePrevAction = ()=>{
        this.props.disableAutoScroll(true);
        this.props.prevAction();
    }

    render() {

        const {
            // component props
            onClickCancel
            , nextAction
            // form
            , wirelessSubscriptionFormA
            // reducer action
            , onVendorSelect
            , onPlanSelect
            , onCircuitTypeSelect
            , onServiceTypeSelect
        } = this.props;

        const { planOptions
            , preferredVendorOptions
            , deviceOptions
            , vendorDetails
            , circuitTypes
            , showDeviceOptions } = this.props.newMobileRequest;

        let disable = wirelessSubscriptionFormA.vendorDetailId === 0
            || wirelessSubscriptionFormA.equipmentCatalogId == 0
            || wirelessSubscriptionFormA.planId === 0
            || wirelessSubscriptionFormA.planId === "";

        const planCost = wirelessSubscriptionFormA.planDetailsModel.length > 0 && wirelessSubscriptionFormA.mobileServiceModel.length > 0 ? wirelessSubscriptionFormA.planDetailsModel[0].dataItem[0].TotalComponentCost : 0;

        const totalOrderCost = wirelessSubscriptionFormA.planId
                         ? (wirelessSubscriptionFormA.mobileServiceModel.length > 0 && wirelessSubscriptionFormA.planDetailsModel.length > 0
                            ? wirelessSubscriptionFormA.mobileServiceModel[0].DiscountedOrderCost + planCost
                            : 0)
                         :0;

        const totalOrderCostFormatted = Number(totalOrderCost).toFixed(2);
        
        if (showDeviceOptions) {
            disable = disable || wirelessSubscriptionFormA.equipmentCatalogId === 0;
        }
        const showServiceWarning = this.state.serviceTypeExist === true && this.state.isDevice && (wirelessSubscriptionFormA.equipmentCatalogId !== undefined || parseInt(wirelessSubscriptionFormA.equipmentCatalogId) === 0); 
        const showExisitingWarning = this.state.serviceTypeExistOnprogress === true && this.state.isDevice && (wirelessSubscriptionFormA.equipmentCatalogId !== undefined || parseInt(wirelessSubscriptionFormA.equipmentCatalogId) === 0);
        const showDeviceDiscountedOrderCost = (wirelessSubscriptionFormA.circuitTypeId === CircuitTypes.mobile_or_cellphone || wirelessSubscriptionFormA.circuitTypeId === CircuitTypes.data_card) && wirelessSubscriptionFormA.equipmentCatalogId !== undefined && parseInt(wirelessSubscriptionFormA.equipmentCatalogId) !== 0;
        return (
            <div >
                <Form method="post" role="form"
                    model="wirelessSubscriptionFormA"                    
                    onSubmit={nextAction}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required custom-wrapper-plan custom-margin'>
                            <CustomSearchableSelectWrapper
                                label={`${this.toLocaleLanguage('vendor')}`}
                                options={preferredVendorOptions.filter(item => item.Value.includes('Preferred'))}
                                selected={wirelessSubscriptionFormA.vendorDetailId}
                                onChange={(e) => {
                                    onVendorSelect('wirelessSubscriptionFormA.vendorDetailId', e.toString())}}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.vendorDetailId'
                                maxLength={MAX_LENGTH.limit_100}
                               optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}                           
                            />
                        </Col>
                    </Row>   
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required custom-wrapper-plan custom-margin'>
                             <CustomSearchableSelectWrapper
                                label={`${this.toLocaleLanguage('circuit_type')}`}
                                options={circuitTypes}
                                selected={wirelessSubscriptionFormA.circuitTypeId}
                                onChange={(val) => onCircuitTypeSelect(val)}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.circuitTypeId'
                                maxLength={MAX_LENGTH.limit_100}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value' 
                                }}
                            /> 
                        </Col>
                    </Row>
                    <Row>
                        <Col className={`${(
                            this.state.serviceTypeExist == true && 
                            (wirelessSubscriptionFormA.equipmentInventoryId != undefined || 
                            wirelessSubscriptionFormA.equipmentInventoryId == 0)) 
                            && 'service-type-container'} required custom-wrapper-plan custom-margin 
                            ${showServiceWarning || showExisitingWarning || showDeviceDiscountedOrderCost? "custom-margin-2px" : ""}`} xs={12} md={12} lg={12}>
                            <CustomSearchableSelectWrapper
                                className="form-control"
                                label={`${this.toLocaleLanguage('mobile_service_type')}`}
                                options={deviceOptions}
                                selected={wirelessSubscriptionFormA.equipmentCatalogId}
                                onChange={(e) =>{
                                     onServiceTypeSelect('.equipmentCatalogId', e)
                                    }}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.equipmentCatalogId'
                                maxLength={MAX_LENGTH.limit_100}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                
                            />
                            {
                            showServiceWarning &&
                                <div><span className='warning-label'>{`${this.toLocaleLanguage('warning_service_type')}`}</span></div>
                            }         
                            {                        
                            showExisitingWarning &&                          
                                    <div><span className='warning-label'>{`${this.toLocaleLanguage('warning_service_type_existing_open_request')}`}</span></div>                       
                            }
                        </Col>
                    </Row>
                    {showDeviceDiscountedOrderCost ?
                        <TableWithButton
                        classNameWrapper="table-details-wrapper detail-list-modal table-padding-sub mt-3"
                        datatable={wirelessSubscriptionFormA.mobileDetailsModel}
                        haveExternalDeleteBtn={false}
                        haveCheckBox={false}                    
                        /> : null
                    }
                       
                    {
                        wirelessSubscriptionFormA.circuitTypeId === CircuitTypes.mobile_or_cellphone && wirelessSubscriptionFormA.equipmentCatalogId !== undefined && wirelessSubscriptionFormA.equipmentCatalogId !== 0 &&
                        <ControlCheckBox
                        classWrapper="custom-checkbox-wrapper"
                        label={`${this.toLocaleLanguage('include_phone_accessory')}`}
                        model="wirelessSubscriptionFormA.phoneCaseAccessory"
                        checked={wirelessSubscriptionFormA.phoneCaseAccessory}
                        />
                    }                  
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required custom-wrapper-plan'>
                            <CustomSearchableSelectWrapper
                                label={`${this.toLocaleLanguage('plan')}`}
                                options={planOptions}
                                selected={wirelessSubscriptionFormA.planId}
                                onChange={(e) => onPlanSelect('.planId', e)}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.planId'
                                maxLength={MAX_LENGTH.limit_100}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                
                            />
                        </Col>
                    </Row>
                    {wirelessSubscriptionFormA.planId?
                          <TableWithButton
                          classNameWrapper="table-details-wrapper detail-list-modal table-padding-sub"
                          datatable={wirelessSubscriptionFormA.planDetailsModel}
                          haveExternalDeleteBtn={false}
                          haveCheckBox={true}                    
                      /> : null
                    }
                  
                    <div className="price-plan-total-cost-container">
                        <div className="price-plan-header">
                            <span><Translation translationKey="total_order_cost" /></span>
                        </div>
                        <div className="price-plan-total">
                            <span>{vendorDetails.Currency}</span>
                            <span>{totalOrderCostFormatted}</span>
                        </div>
                    </div>
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <Button
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <Button
                                    label={this.toLocaleLanguage('back')}
                                    variant={"outline-secondary"}
                                    action={this.handlePrevAction}
                                    className="btn-custom-violet-hover-outline"
                                    type="button"
                                />
                            </div>
                            <div>
                                <Button
                                    label={this.toLocaleLanguage('next_button')}
                                    variant={"primary"}
                                    type={"submit"}
                                    disabled={disable}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};


export default connect(
    state => {
        const { newMobileRequest, translation } = state;
        const { wirelessSubscriptionFormA } = state.form;
        return {
            newMobileRequest
            , wirelessSubscriptionFormA
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newMobileSubscriptionActions),
            dispatch
        )
)(WirelessSubscriptionFormA);
